export default __webpack_public_path__ + "static/media/spin.3e029f79.gif";